import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { FlexSmallCardContainer } from '../../../Cards/Small';
import breakpoints from '../../../Theme/breakpoints';

const OuterContainer = styled.div`
  margin-bottom: 24px;

  @media (min-width: ${breakpoints.lg}px) {
    display: grid;
    grid-template-columns: 1fr 325px;
  }
  @media (min-width: 1400px) {
    grid-template-columns: 74% 26%;
  }

  min-height: 1000px;
`;

const InnerContainer = styled.div`
  display: grid;

  @media (min-width: ${breakpoints.md}px) {
    grid-template-columns: 35% 65%;
  }
  @media (min-width: ${breakpoints.lg}px) {
    grid-template-columns: 35% 65%;
  }
`;

const SpotlightArticle = styled.div`
  padding: 0 0 24px;

  @media (min-width: ${breakpoints.md}px) {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    padding: 0 0 0 16px;
  }

  @media (min-width: ${breakpoints.lg}px) {
    padding: 0 24px;
    margin: 0 auto;
    border: none;
    width: calc(100% - 48px);
  }
`;

const LastArticle = styled.div`
  padding: 0 0 24px;
  order: 4;

  @media (min-width: ${breakpoints.md}px) {
    grid-column: 1 / 3;
    grid-row: 3;
  }

  @media (min-width: ${breakpoints.sm}px) {
    padding: 16px 0;
    margin: 16px 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors?.greyLight};
    border-top: 1px solid ${({ theme }) => theme.colors?.greyLight};
  }

  @media (min-width: ${breakpoints.lg}px) {
    border-bottom: none;
    margin: 24px 24px 0 0;
    padding: 24px 0 0;
  }
`;

const SideBar = styled.section`
  width: 100%;

  @media (min-width: ${breakpoints.lg}px) {
    width: 300px;
    padding-left: 24px;
    border-left: 1px solid ${({ theme }) => theme.colors?.greyLight};
  }

  @media (min-width: 1400px) {
    width: unset;
  }
`;

const SideBarArticles = styled.div`
  @media (min-width: ${breakpoints.md}px) {
    grid-column: 1 / 2;
    grid-row: 1 / 3;
    padding: 0 16px 0 0;
    border-right: 1px solid ${({ theme }) => theme.colors?.greyLight};
  }

  @media (min-width: ${breakpoints.lg}px) {
    padding: 0 24px 0 0;
  }
`;

const Featured = ({
  spotlightArticle, sidebarArticles, wideArticle, sideBar,
}) => (
  <OuterContainer>
    <section>
      <InnerContainer>
        <SpotlightArticle>
          {spotlightArticle}
        </SpotlightArticle>
        <SideBarArticles>
          <FlexSmallCardContainer>
            {sidebarArticles}
          </FlexSmallCardContainer>
        </SideBarArticles>
        <LastArticle>
          {wideArticle}
        </LastArticle>
      </InnerContainer>
    </section>
    <SideBar>
      {sideBar}
    </SideBar>
  </OuterContainer>
);

Featured.propTypes = {
  spotlightArticle: PropTypes.node,
  sidebarArticles: PropTypes.node,
  wideArticle: PropTypes.node,
  sideBar: PropTypes.node,
};

Featured.defaultProps = {
  spotlightArticle: undefined,
  sidebarArticles: undefined,
  wideArticle: undefined,
  sideBar: undefined,
};

export default Featured;
